import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Device APIs
export const deviceAPI = {
  register: (data) => axios.post(`${API_BASE_URL}/devices/register`, data),
  getAll: () => axios.get(`${API_BASE_URL}/devices`),
  getById: (deviceId) => axios.get(`${API_BASE_URL}/devices/${deviceId}`),
  updateStatus: (deviceId, status) => 
    axios.patch(`${API_BASE_URL}/devices/${deviceId}/status`, { status }),
  update: (deviceId, data) => axios.patch(`${API_BASE_URL}/devices/${deviceId}`, data),
  delete: (deviceId) => axios.delete(`${API_BASE_URL}/devices/${deviceId}`)
};

// Node APIs
export const nodeAPI = {
  register: (data) => axios.post(`${API_BASE_URL}/nodes/register`, data),
  getAll: () => axios.get(`${API_BASE_URL}/nodes`),
  getByDevice: (deviceId) => axios.get(`${API_BASE_URL}/nodes/device/${deviceId}`),
  getById: (nodeId) => axios.get(`${API_BASE_URL}/nodes/${nodeId}`),
  updateStatus: (nodeId, status) => 
    axios.patch(`${API_BASE_URL}/nodes/${nodeId}/status`, { status }),
  update: (nodeId, data) => axios.patch(`${API_BASE_URL}/nodes/${nodeId}`, data),
  delete: (nodeId) => axios.delete(`${API_BASE_URL}/nodes/${nodeId}`)
};

// Meter Data APIs
export const meterAPI = {
  sendData: (data) => axios.post(`${API_BASE_URL}/meter/data`, data),
  getLatest: (deviceId, nodeId) => 
    axios.get(`${API_BASE_URL}/meter/latest/${deviceId}/${nodeId}`),
  getHistory: (deviceId, nodeId, params) => 
    axios.get(`${API_BASE_URL}/meter/history/${deviceId}/${nodeId}`, { params }),
  getDeviceLatest: (deviceId) => 
    axios.get(`${API_BASE_URL}/meter/device/${deviceId}/latest`)
};

// Health check
export const healthCheck = () => axios.get(`${API_BASE_URL}/health`);

export default {
  deviceAPI,
  nodeAPI,
  meterAPI,
  healthCheck
};
